// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "switcher-jitr1";
var _4 = "switcher_alternative-1diwZ";
export { _1 as "__esModule", _2 as "mobile", _3 as "switcher", _4 as "switcher_alternative" }
export default { "__esModule": _1, "mobile": _2, "switcher": _3, "switcher_alternative": _4 }
